export default __webpack_public_path__ + "static/media/PlannedIcon@2xwhite.332e9f6b.png";